    const color_def_content = document.getElementById('colors-def-content');
    const color_def_click = document.getElementById('colors-def-click');

    color_def_click.addEventListener('click', () => {
    if (color_def_content.style.display === 'block') {
        color_def_content.style.display = 'none';
    } else {
        color_def_content.style.display = 'block';
    }
    });

   const perfect_bot_divs = document.getElementById('Perfect-fit');
    const perfect_bot_click = document.getElementById('Perfect-fit-content');

    perfect_bot_click.addEventListener('click', () => {
    if (perfect_bot_divs.style.display === 'block') {
        perfect_bot_divs.style.display = 'none';
    } else {
        perfect_bot_divs.style.display = 'block';
    }
    });

 const radioButtons = document.querySelectorAll('.product-fit-selection');

        radioButtons.forEach((radio) => {
          radio.addEventListener('change', function (e) {
            // Remove the 'selected' class from all labels
            radioButtons.forEach((radioButton) => {
              radioButton.parentNode.classList.remove('has-box-shadow');
              radioButton.parentNode.querySelector('p').style.display = 'none';
            });

            e.target.parentNode.classList.add('has-box-shadow');
            e.target.parentNode.querySelector('p').style.display = 'block';
          });
        });


  const modalDetails = document.getElementById("modalPopupDetails");
  const closeButtonDetails = document.querySelector(".close-buttonDetails");
  const openModalButtonDetails = document.getElementById("openModalDetails");

  closeButtonDetails.addEventListener("click", () => {
    modalDetails.style.display = "none";
  });

  window.addEventListener("click", (event) => {
    if (event.target === modalDetails) {
      modalDetails.style.display = "none";
    
    }
  });

  openModalButtonDetails.addEventListener("click", () => {
    modalDetails.style.display = "block";
  });